@if (isLoading$ | async) {
  <div class="ds-loader">
    <ds-loader></ds-loader>
  </div>
}
<ss-global-loader></ss-global-loader>
<main class="l-pageMain main" tabindex="-1" id="mainContent" [ngClass]="{ 'pt-0': !hasGlobalHeaderFooter }">
  @if (isLoggedIn$ | async) {
    <fss-secondary-nav></fss-secondary-nav>
    <fss-page-alert></fss-page-alert>
    <fss-breadcrumbs></fss-breadcrumbs>
    <div class="container">
      <router-outlet></router-outlet>
    </div>
    <router-outlet name="noContainer"></router-outlet>
    <router-outlet name="customOutlet"></router-outlet>
  } @else {
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  }
</main>
